import { captureException } from '@sentry/browser';
import { ZodError } from 'zod';
import { Intent, ProgressBar } from '@blueprintjs/core';
import { styled } from '@moleculeone/ui';

import { apiClient } from '@f/api-client';
import { AppToaster } from '@f/components/notification-toaster/AppToaster';
import { downloadFile } from '@f/utils/export';

const DOWNLOADING_REPORT_TOAST_KEY = 'downloading_report_toast';

const ToastSpan = styled('span', { display: 'block', marginBottom: '0.3em' });

export const getReportPdf = async (id: string) => {
  try {
    AppToaster.show(
      {
        message: (
          <>
            <ToastSpan>Downloading report...</ToastSpan>
            <ProgressBar value={100} intent={Intent.PRIMARY} />
          </>
        ),
        timeout: 0,
        isCloseButtonShown: false,
      },
      DOWNLOADING_REPORT_TOAST_KEY
    );

    const { status, body } = await apiClient.report.getPdfFile({
      params: { id },
      headers: {
        'content-type': 'application/pdf',
      },
    });

    if (status !== 200) {
      throw new Error(String(body));
    }

    const blobUrl = window.URL.createObjectURL(body);
    const currentTime = new Date();
    downloadFile(blobUrl, `M1-RetroScore_Report-${currentTime.toISOString()}.pdf`);

    AppToaster.show(
      {
        intent: Intent.SUCCESS,
        message: <span data-cy="text-report-download-completed">Download completed</span>,
        icon: 'tick',
        timeout: 1500,
      },
      DOWNLOADING_REPORT_TOAST_KEY
    );
  } catch (error) {
    if (error instanceof ZodError) {
      captureException(error);
    }
    return error;
  }
};
